import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ConfirmModal from "../../../components/Modals/ConfirmModal/ConfirmModal.component";

import SampleExcel from "../../../assets/files/credits-sample.xlsx";

const CreditsCreateByExcel = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('credits'), link: '/credits-list' },
		{ title: t('create') }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};
	const [errors, setErrors] = useState([]);

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createCredits = event => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let excelFile = document.querySelector('#creditExcelFile-upload-list a')?.getAttribute('href').trim();
		if(!typeChecker(excelFile, 'image'))
			return toast.warn(t('file') + ' ' + t('cant_be_empty'));
		let body = {
			excel_file: excelFile
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/credits/admin/createByExcel', body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					event.target.reset();
					setErrors(response.data.errorTradeCodes);
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};
	
	return <>
		<Breadcrumb items={breadcrumbItems} />
		<div className="card mb-3">
			<div className="card-header">
				<h5 className="mb-0">{t('create')} {t('credits')}</h5>
			</div>
			<div className="card-body bg-light">
				<form onSubmit={createCredits}>
					<div className="row gx-2">
						<FormField type="file" fieldKey="creditExcelFile" title={t('file')} fileMaxSize={2} />
						<div className="col-md-6">
							<Link className="btn btn-warning btn-sm" to={SampleExcel} target="_blank">دانلود فایل نمونه</Link>
						</div>
						<FormField type="text" fieldKey="creditErrors" title={t('troubled_trading_codes')} value={errors.length ? errors.map((error, i) => `${i+1}: ${error}\n`) : t('no_errors')} disabled ltr />
					</div>
					<div>
						<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
							<i className="fa fa-save"></i> {t('create')}
						</LoadingButton>
					</div>
				</form>
			</div>
		</div>
        <ConfirmModal action={createCredits} />
	</>;
};

export default CreditsCreateByExcel;
